
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  mounted: function () {
    var self = this;
    var app = self.$app;
    self.getUsers();
    var map = new google.maps.Map(document.getElementById('lmap'), {
      center: {
        lat: parseFloat(self.location.latitude),
        lng: parseFloat(self.location.longitude)
      },
      zoom: 15,
      disableDefaultUI: true,
      mapTypeId: google.maps.MapTypeId.HYBRID,
      styles: [{
        "featureType": "administrative",
        "elementType": "all",
        "stylers": [{
          "saturation": "-100"
        }]
      }, {
        "featureType": "administrative.province",
        "elementType": "all",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [{
          "saturation": -100
        }, {
          "lightness": 65
        }, {
          "visibility": "on"
        }]
      }, {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [{
          "saturation": -100
        }, {
          "lightness": "50"
        }, {
          "visibility": "simplified"
        }]
      }, {
        "featureType": "road",
        "elementType": "all",
        "stylers": [{
          "saturation": "-100"
        }]
      }, {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [{
          "visibility": "simplified"
        }]
      }, {
        "featureType": "road.arterial",
        "elementType": "all",
        "stylers": [{
          "lightness": "30"
        }]
      }, {
        "featureType": "road.local",
        "elementType": "all",
        "stylers": [{
          "lightness": "40"
        }]
      }, {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [{
          "saturation": -100
        }, {
          "visibility": "simplified"
        }]
      }, {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [{
          "hue": "#378cff"
        }, {
          "lightness": 0 //-25

        }, {
          "saturation": 0 //-97

        }]
      }, {
        "featureType": "water",
        "elementType": "labels",
        "stylers": [{
          "lightness": -0
        }, {
          "saturation": -0
        }]
      }],
      mapTypeControl: true,
      mapTypeControlOptions: {
        mapTypeIds: [google.maps.MapTypeId.HYBRID, google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.SATELLITE, google.maps.MapTypeId.TERRAIN],
        position: google.maps.ControlPosition.LEFT_TOP,
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
      }
    });
    var marker = new google.maps.Marker({
      position: {
        lat: parseFloat(self.location.latitude),
        lng: parseFloat(self.location.longitude)
      },
      map: map,
      icon: {
        url: 'https://static.app.mitsulift.com/images/map-marker.svg',
        // This marker is 20 pixels wide by 32 pixels high.
        size: new google.maps.Size(30, 42),
        scaledSize: new google.maps.Size(30, 42),
        // The origin for this image is (0, 0).
        origin: new google.maps.Point(0, 0),
        // The anchor for this image is the base of the flagpole at (0, 32).
        anchor: new google.maps.Point(15, 42)
      }
    });
  },
  on: {
    pageBeforeIn() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.isAdjustEnabled();
    }

  },
  methods: {
    suggestCoords() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.$router.navigate("/adjust-location/", {
        context: {
          location: self.location
        }
      });
    },

    isAdjustEnabled() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.$app.request({
        url: Url.to("location/is-adjust-allowed"),
        method: "GET",
        data: {
          location_id: self.location.id
        },
        preloader: false,
        indicator: false,
        progress: false,
        success: function (data, status, xhr) {
          console.log(data);
          self.allow_adjust = data['allowed'];
          self.$update();
        }
      });
    },

    updateFloorNumber() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      var dialog = self.$app.dialog.prompt("Enter your floor number", function (floor_number) {
        console.log(floor_number);
        self.$app.request({
          url: Url.to("location/update-floor"),
          method: "POST",
          data: {
            location_id: self.location.id,
            floor_number: floor_number
          },
          preloader: false,
          indicator: false,
          progress: false,
          success: function (data, status, xhr) {
            console.log(data);
            self.location.floor_number = floor_number;
            self.$update();
          }
        });
      }); //$$("input", dialog.el).attr("type", "number");

      $$("input", dialog.el).val(self.location.floor_number);
      $$("inout", dialog.el).trigger("change");
      console.log(dialog);
    },

    removeLocation: function (id) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.$app.dialog.confirm('Are you sure you want to remove this location?', function () {
        app.request({
          url: Url.to("location/remove"),
          method: "POST",
          preloader: true,
          progress: false,
          data: {
            location_id: id
          },
          success: function (data, status, xhr) {
            self.$app.dialog.alert('Location successfully removed.', function () {
              // location.reload();
              self.$router.back("/my-mitsu/", {
                force: true
              });
            });
          }
        });
      });
    },
    manageEquipments: function () {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      console.log(self.location);
      self.$router.navigate("/manage-equipments/", {
        context: {
          location: self.location
        }
      });
    },

    getUsers() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.$app.request({
        url: Url.to("location/get-users"),
        method: "GET",
        data: {
          location_id: self.location.id
        },
        preloader: false,
        indicator: false,
        progress: false,
        success: function (data, status, xhr) {
          console.log(data);
          self.users = data;
          self.$update();
        }
      });
    },

    requestRemove(id) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.$app.dialog.prompt('Reason to remove this user?', function (reason) {
        app.request({
          url: Url.to("location/request-remove"),
          method: "POST",
          preloader: true,
          progress: false,
          data: {
            location_id: self.location.id,
            id: id,
            reason: reason
          },
          success: function (data, status, xhr) {
            self.$app.dialog.alert('Request successfully sent.');
          }
        });
      });
    }

  },
  data: function () {
    //console.log(this);
    var location = this.$route.context.location; //console.log(location);
    //            var currentArticle;
    //            this.$root.news.forEach(function (article) {
    //                if (article.id === articleId) {
    //                    currentArticle = article;
    //                }
    //            });

    return {
      users: [],
      location: location,
      allow_adjust: false
    };
  },
  id: 'b0e955659b',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page no-toolbar" data-name="location">\n        <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back">\n                        <i class="icon icon-back"></i>\n                        <span class="if-not-md">My Mitsu</span>\n                    </a>\n                </div>\n                <div class="title">';
      r += c(ctx_1.location.name, ctx_1);
      r += '</div>\n                <div class="right"></div>\n            </div>\n        </div>\n        <div class="page-content">\n\n            <div class="block map-block no-margin no-padding">\n                <div id="lmap" style="width:100%;height:100vw; max-height: 400px;"></div>\n                ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.allow_adjust, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div class="map-overlay">\n                    <a @click="suggestCoords" class="button bg-color-white button-outline color-primary" href="#" style="border-radius: 50px">\n                        <i class="icon material-icons" style="font-size: 16px">location_on</i>\n                        Adjust\n                    </a>\n                </div>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            </div>\n\n            <div class="block-title">Location Details</div>\n            <div class="list no-margin-bottom">\n                <ul>\n                    <li>\n                        <div class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Name</div>\n                                    ';
      r += c(ctx_1.location.name, ctx_1);
      r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    <li class="display-none">\n                        <div class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Code</div>\n                                    ';
      r += c(ctx_1.location.code, ctx_1);
      r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    <li>\n                        <div class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Address</div>\n                                    ';
      r += c(ctx_1.location.address, ctx_1);
      r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    <li>\n                        <div class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Floor Number</div>\n                                    ';
      r += c(ctx_1.location.floor_number, ctx_1);
      r += '\n                                </div>\n                                <div class="item-after">\n                                    <div class="row">\n                                        <a @click="updateFloorNumber" class="col button button-round link" href="#">\n                                            <i class="icon material-icons">edit</i>\n                                        </a>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                    <li class="display-none">\n                        <div class=" item-content">\n                            <div class="item-inner">\n                                <div class="item-title">\n                                    <div class="item-footer">Customer</div>\n                                    ';
      r += c(ctx_1.location.customer, ctx_1);
      r += '\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                </ul>\n            </div>\n            <div class="block no-margin">\n                <div class="row">\n                    <button class="button margin-vertical-half col" @click="manageEquipments">\n                        Manage Equipments Visibility\n                    </button>\n                </div>\n\n                <div class="row">\n                    <button class="button color-red col" @click="removeLocation(';
      r += c(ctx_1.location.id, ctx_1);
      r += ')">\n                        Remove Location From Account\n                    </button>\n                </div>\n            </div>\n\n            ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.users.length > 0', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <hr/>\n            <div class="data-table">\n                <table>\n                    <thead>\n                    <tr>\n                        <th class="label-cell">User</th>\n                        <th class="label-cell">Role</th>\n                        <th class="label-cell">Remove</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.users, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <tr>\n                        <td class="label-cell">';
              r += c(ctx_3.user, ctx_3);
              r += '</td>\n                        <td class="label-cell">';
              r += c(ctx_3.role_label, ctx_3);
              r += '</td>\n                        <td class="label-cell">\n                            <a href="#" class="button button-small color-red" @click="requestRemove(';
              r += c(ctx_3.id, ctx_3);
              r += ')">\n                                Remove\n                            </a>\n                        </td>\n                    </tr>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                    </tbody>\n                </table>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    